<template>
  <div>
    <div v-if="debug_show_page_name==true" style="color:green;">log-history-modal</div>
    <modal class="log_history-modal" width="980px"   :value="showModal" effect="fade" @closed="closed"  large>
      <!-- custom header -->
      <div slot="modal-header" class="modal-header">
        <h4 class="modal-title">
          <center><strong>更新履歴</strong></center>
        </h4>
      </div>
      <div  class="modal-body log_history-modal-body " style="height: 500px;padding: 0px 15px; overflow-x: auto;" >
        <ag-grid-vue style="min-width:100px;width: 100%; height: 475px" class="ag-blue" :gridOptions="gridOptions" :rowData="rowData"></ag-grid-vue>
      </div>
      <div slot="modal-footer" class="modal-footer" style="background:white">
        <div style="float:left">
        </div>
        <button type="button" class="btn btn-default " @click="closed('no')">戻る</button>
      </div>
    </modal>
  </div>
</template>

<script>
import Vue from 'vue';
import { bus } from '@/libs/bus';
import { utils } from '@/libs/utils';
var vm = this;

import modal from './local-modal';
import output_config from '../../rules/output_config.js';
import { AgGridVue } from 'ag-grid-vue';
import mixinPageCommon from "@/mixins/mixin_page_common";
import mixinDatasource from "@/mixins/mixin_datasource";
import { fields, filed_types } from '@/rules/fields_log_history';

Vue.component('modal', modal);
import _ from 'lodash';
import debug from 'debug';
var debug_log_history = debug('esma:log_history');
export default {
   mixins:[
        mixinPageCommon,mixinDatasource
  ],
  components: {
    'ag-grid-vue': AgGridVue
  },
  data() {
    return {
      show_modal: false,
      selected_data :false,
      row_data:[],
      api_name:"log_history",
      search_timeout : false,
      search_model:""
    };
  },
  computed: {
    searchModel:{
      get(){
        return this.search_model;
      },
      set(v){
        this.search_model = v;
      }
    },
    rowData:{
      get(){
        return this.row_data;
      },
      set(v){
        this.row_data = v;
      }
    },
    selectedData:{
      get(){
        return this.selected_data;
      },
      set(v){
        this.selected_data = v;
      }
    },

    pageID() {
      return this.$props.pageid;
    },
    showModal() {
      return this.show_modal;
    },
    tabFieldList() {
      return [
        utils.extend(fields.change_time, {type:filed_types.CURRENT_TIME}),
        utils.extend(fields.user_shimei, {}),
        utils.extend(fields.log_tab, {}),
        utils.extend(fields.field_name, {}),
        utils.extend(fields.value_before, {}),
        utils.extend(fields.value_after, {})
      ];
    }
  },
  methods: {

    createColumnDefs() {
      return this.commonCreateColumnDefs({show_details:false,show_checkbox:false})
    },
    onSearch(txt,data){
      // clearTimeout(this.search_timeout);
      // this.search_timeout = setTimeout(()=>{
        var fk_id = data.fk_id;
        var fk_tab = data.fk_tab;
        this.searchControlChangedDatasource(
          {
            "1":{block: "1", field: "fk_tab", value: ""+fk_tab, ct: "v", ca: false, t: "input",exact_value:true},
            "2": {block: "2", field: "fk_id", value: ""+fk_id, ct: "v", ca: false, t: "input",exact_value:true},
            "3": false,
            "j1": "AND",
            "j2": "AND",
            "b2_disabled": false,
            "b3_disabled": true
          }
        )
      // },(txt =="")?0:300)
    },
    cancelCurrentSelection() {
      //Dummy, needed due mixinDataSource
    },
    updateValue(vm, ev, mode, cb=()=>{}){
      if (ev.node.isSelected()) {
        this.selectedData = ev.node.data.number_cert;
      }
    },
    onShow(data) {
      this.searchModel = "";
      this.selectedData = false;
        this.$notify({clean: true});
      this.$notify({
        title: "Loadding....",
        type: "success",
        duration: 1000
      });
      this.onSearch("",data);
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },500)
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },1000)
      setTimeout(()=>{
        this.gridOptions.api.sizeColumnsToFit();
      },3000)
    },
    showModalWindow(data) {
      debug_log_history("showModalWindow");
      this.onShow(data);
      this.show_modal = true;
    },
    closed(mode) {
      this.show_modal = false;
      this.$emit('done', mode);
    },

  },
  props: {
    tag: { type: String, default: 'showLogHistory' },
    pageid: { type: String },
    fk_tab: { type: String },
    fk_id: { type: String },
  },
   beforeMount() {
    // this.$store.state.current_row = {};

    //AG Grid options
    this.gridOptions = _.extend(this.commonGridOptions,{}) ;
    this.initDatasource({load_only_with_filter:true});
  },
  mounted() {
    debug_log_history('On mounted');
    bus.$on(this.$props.tag, this.showModalWindow);
  },
  beforeDestroy() {
    bus.$off(this.$props.tag);
  }
};

</script>
<style scoped>

.info_div {
  width: 32%;
  float: left;
}
.mh_td2 {
  margin: 2px 0px;
  border: 0px solid #bdbdbd;

  font-size: 11px;
  font-weight: 500;
  padding: 4px 0px 4px 4px;
}

.mh_td_h2 {
  margin: 2px 0px;
  _border: 1px solid #bdbdbd;
  _background-color: #b4d5f1;
  padding: 4px 8px;
  font-size: 11px;
  _font-weight: 900;
}
.fa-spin-custom, .glyphicon-spin {
    -webkit-animation: spin 1500ms infinite linear;
    animation: spin 1500ms infinite linear;
}

@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
</style>



// WEBPACK FOOTER //
// log-history-modal.vue?2c0af12e